<script setup lang="ts">
import UploadStatus from "@/components/CvrConvert/VehiclesListParts/UploadStatus.vue"
import UploadRequestPanel from "@/components/CvrConvert/UploadRequestPanel.vue"
import cvrUploadSummariesData from "@/types/responses/cvrUploadSummariesData"
import CvrUploadPeriod from "@/types/responses/getCvrUploadPeriod"
import getVehicleResponse from "@/types/responses/getVehicle"
import { Ref, ref, computed } from 'vue'
import Api from "@/services/api/ApiServiceFabrick"
import { ALL_DEVICE_TYPE } from "@/services/consts"
import i18n from '@/lang/i18n';

const emit = defineEmits(['openCvrList'])
const props = defineProps<{
  item: cvrUploadSummariesData
  reload: () => void
  showFlash: (message: string, type: string, fadeout: boolean) => {value: any}
  vehicleWidth: string
  acordionItemStyle: string
  isDisplayCvrList: boolean
  vehicle: cvrUploadSummariesData
  searchWindowStatus: boolean
  createAuthority: boolean
}>()

const requestModalStatus: Ref<boolean> = ref(false)
const reading: Ref<boolean> = ref(false)
const selectedVehicle = ref({} as getVehicleResponse)
const ranges = ref<{start_at: Date, end_at: Date}[]>([])
const selectedVehicleId: Ref<number | null> = ref(null)

const groupNames = computed(() => {
  let names = ""
  props.item.group_names.forEach((name, index) => {
    if (index == 0) {
      names += name
    } else {
      names += `, ${name}`
    }
  })
  return names
})

const deviceModelType = computed(() => {
  return ALL_DEVICE_TYPE.filter((device: {type: string, id: number}) => {
    return device.id == props.item.device_model_type
  })[0].type
})

const openRequestModal = () => {
  requestModalStatus.value = true
  reading.value = true
  getVehicle(props.item.id)
}

const getVehicle = (id: number) => {
  Api().getAutoCompleteVehicle(id).then((response) => {
    selectedVehicle.value = response
    getCvrUploadPeriods(response.digital_tacograph)
  })
}

const getCvrUploadPeriods = (deviceId: number) => {
  Api().getCvrUploadPeriods(deviceId).then((res) => {
    reading.value = false;
    if (!res) return
    ranges.value = toDateRanges(res);
  })
}

const toDateRanges = (responses: CvrUploadPeriod[]) => {
  let periods = [] as { start_at: Date, end_at: Date }[];
  responses.forEach((response: { start_at: string, end_at: string }) => {
    const period = {
      start_at: new Date(response.start_at),
      end_at: new Date(response.end_at)
    } as { start_at: Date, end_at: Date }
    periods.push(period)
  })
  return periods;
}

const openCvrList = () => {
  if (props.searchWindowStatus) return
  selectedVehicleId.value = props.item.id
  emit('openCvrList', true, props.item)
}

const selectedVehicleBgColor = computed(() => {
  return props.isDisplayCvrList && props.item.id == props.vehicle.id ? 'background-color: #66cdaa' : ''
})
</script>
<template>
  <tr>
    <td
      :id="String(props.item.id)"
      :class="props.vehicleWidth"
      :style="selectedVehicleBgColor"
    >
      <div :class="props.isDisplayCvrList ? '' : 'mx-4'">
        {{ props.item.number_plate }}
      </div>
    </td>
    <td
      :style="props.acordionItemStyle"
    >
      <div class="mx-4">
        {{ props.item.department_name }}
      </div>
    </td>
    <td
      :style="props.acordionItemStyle"
    >
      <div class="mx-4">
        {{ groupNames }}
      </div>
    </td>
    <td
      :style="props.acordionItemStyle"
      class="text-center"
    >
      {{ deviceModelType }}
    </td>
    <td
      :style="props.acordionItemStyle"
      class="text-center"
    >
      {{ props.item.count }}
    </td>
    <td
      :style="props.acordionItemStyle"
      class="text-center"
    >
      <v-btn
        @click="openCvrList"
      >
        {{ i18n.global.t('pages.cvr_uploads.list.getVideoList') }}
      </v-btn>
    </td>
    <UploadStatus
      :item="props.item"
      :acordionItemStyle="props.acordionItemStyle"
      :openRequestModal="openRequestModal"
    />
  </tr>
  <UploadRequestPanel
    v-model="requestModalStatus"
    :reload="props.reload"
    :showFlash="props.showFlash"
    :reading="reading"
    :ranges="ranges"
    :selectedVehicle="selectedVehicle"
    :createAuthority="props.createAuthority"
  />
</template>
<style scoped>
.vehicle {
  transition: 0.5s;
}
.vehicle.closed {
  width: 100%;
}
.acordion-items.closed {
  display: none;
}
</style>
